// extracted by mini-css-extract-plugin
export default {"ServiceItem":"ServiceItem_ServiceItem__dcHr+","ServiceName":"ServiceItem_ServiceName__ShEkT"};